/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}tooltip`;
const observedAttributes = {
    ID: 'id',
    OPEN: 'open',
    TYPE: 'type',
    ANCHOR: 'anchor',
    TARGET: 'target', // deprecated
    PLACEMENT: 'placement',
    POSITION: 'position', // deprecated
    DELAY: 'delay',
    OFFSET: 'offset',
    FLIP: 'flip',
    BOUNDARY: 'boundary',
    FALLBACK_PLACEMENTS: 'fallback-placements',
    TRIGGER_TYPE: 'trigger-type'
};
const attributes = {
    ...observedAttributes
};
const numbers = {
    LONGPRESS_VISIBILITY_DURATION: 3000
};
const defaults = {
    DELAY: 500,
    OFFSET: 4,
    FLIP: 'auto',
    TYPE: 'presentation',
    PLACEMENT: 'right',
    TRIGGER_TYPES: ['hover']
};
const selectors = {
    CONTENT: '.forge-tooltip',
    ARROW: '.arrow'
};
export const TOOLTIP_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    numbers,
    defaults,
    selectors
};
